import { defineComponent } from 'vue';

import ErrorPage from './ErrorPage.class';

export default defineComponent({
	setup: () => {
		const component = new ErrorPage();

		return {
			goToRoot: component.goToRoot.bind(component)
		};
	}
});
